import { Pagination } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

const Paginate = ({ pages, page, isAdmin = false, keyword = "", onPageChange }) => {
  return (
    pages > 1 && (
      <Pagination size="lg">
        {[...Array(pages).keys()].map((x) => (
          onPageChange ? (
            <Pagination.Item
              key={x + 1}
              active={x + 1 === page}
              onClick={() => onPageChange(x + 1)}
            >
              {x + 1}
            </Pagination.Item>
          ) : (
            <LinkContainer
              key={x + 1}
              to={
                !isAdmin
                  ? keyword
                    ? `/search/${keyword}/page/${x + 1}`
                    : `/page/${x + 1}`
                  : `/admin/productlist/${x + 1}`
              }
            >
              <Pagination.Item active={x + 1 === page}>{x + 1}</Pagination.Item>
            </LinkContainer>
          )
        ))}
      </Pagination>
    )
  );
};

export default Paginate;
